module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/919f80062b14819e7e89e9dbf77e16db.png";